import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export const useMasterSubjectsSelector = () => useSelector((state: RootState) => state.masterData.subjects);

export const useMasterGradesSelector = () => useSelector((state: RootState) => state.masterData.grades);

export const useMasterSchoolYearsSelector = () => useSelector((state: RootState) => state.masterData.schoolYears);

export const useExerciseFormatsSelector = () => useSelector((state: RootState) => state.masterData.exerciseFormats);

export const useExamEditExamRequestSelector = () => useSelector((state: RootState) => state.examEdit.examRequest);

export const useExamEditErrorSelector = () => useSelector((state: RootState) => state.examEdit.examImportError);

export const useExamEditSubjectSelector = () => useSelector((state: RootState) => state.examEdit.subject);

export const useMasterSkillTypesSelector = () => useSelector((state: RootState) => state.masterData.skillTypes);

export const useAppConfigSelector = () => useSelector((state: RootState) => state.appConfig);

export const useMasterUserSelector = () => useSelector((state: RootState) => state.masterData.user);

export const useMasterFeedBackTypeSelector = () => useSelector((state: RootState) => state.masterData.feedBackTypes);

export const useQuestionEditSelector = () => useSelector((state: RootState) => state.editQuestionModal);

export const useExamTemplateRequestSelector = () =>
  useSelector((state: RootState) => state.examTemplateEdit.examTemplateRequest);

export const useAppConfigIsLoading = () => useSelector((state: RootState) => state.appConfig.isLoading);

export const useExamEditPractice = () => useSelector((state: RootState) => state.examEdit.practice);
